import type { ResumeState } from './cost-to-build-client-ui-resume.types';

export const RESUME_INITIAL_STATE: ResumeState = {
    description: 'Estimation indicative hors taxes. Un devis détaillé vous sera fourni après étude de votre projet.',
    maxPrice: 0,
    minPrice: 0,
};

export const areResumeStatesEqual = (left: ResumeState, right: ResumeState) =>
    left.description === right.description && left.maxPrice === right.maxPrice && left.minPrice === right.minPrice;
